import { MembersViewContainer } from 'src/containers/Escrow/Members';
import { useSoftwareEscrow } from 'src/context/software-escrow';
import { EscrowPartyTypeEnum } from 'src/graphql/schema';

const SoftwareEscrowMembers = () => {
  const {
    softwareEscrow: {
      status,
      currentCompanyRole,
      [currentCompanyRole as EscrowPartyTypeEnum]: party,
      escrowInvitation,
    },
  } = useSoftwareEscrow();

  return (
    <div className="container mx-auto">
      <MembersViewContainer
        escrowPartyId={party!.id}
        canAdd={party!.policy.createEscrowMembers}
        escrowInvitationStatus={escrowInvitation?.status}
        escrowStatus={status}
      />
    </div>
  );
};

export default SoftwareEscrowMembers;
